module.exports = __webpack_public_path__ + "img/3.f329c474.jpg";